var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-container"},[_c('v-card',[_c('v-card-title',[_vm._v(" Users "),_c('v-spacer')],1),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.rows,"search":_vm.search,"footer-props":{
          'items-per-page-options': [5, 10, 15]
        },"items-per-page":5},on:{"pagination":_vm.updatePagination}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }